<template>
  <IframeWrap :title="content.description" :class="layout" :option="wrapSize" @loaded="handleLoad">
    <div v-if="!isHttps" class="text-red-600 text-xl m-4 text-left">
      <span class="block">1. 内嵌语法请使用 https 链接。</span>
      <span class="block">2. http 链接可能会造成您的信息泄漏。当前暂不支持 http 链接。</span>
    </div>
    <iframe
      v-else
      ref="contentIframe"
      :data-src="content.url"
      sandbox=" allow-forms allow-modals allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
      width="100%"
      frameborder="0"
      @load="handleLoad"
    ></iframe>
  </IframeWrap>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { isProd } from '@forchange/utils';
import { namespace } from 'vuex-class';
import IframeWrap from '@/components/iframe-wrap';
import { IIframewrap } from '@/components/iframe-wrap/type';

const commonMadel = namespace('common');

@Component({
  components: {
    IframeWrap
  }
})
export default class Iframe extends Vue {
  @Prop({ type: Object }) content!: Content & { url: string; align: string } & IIframewrap;
  @commonMadel.State('clewordNavVisible') clewordNavVisible: boolean;
  @commonMadel.State('setyleNavHeight') setyleNavHeight: number;

  isEnlarge = false;

  get layout() {
    const layout: Array<String> = [];
    switch (this.content.align) {
      case '居中':
      case 'center':
        layout.push('justify-center');
        break;
      case '居右':
      case 'right':
        layout.push('justify-end');
        break;
      default:
        layout.push('justify-start');
        break;
    }
    return layout.join(' ');
  }

  get isHttps() {
    return this.content.url.startsWith('https');
  }

  get wrapSize() {
    return {
      width: this.content.width,
      height: this.content.height
    };
  }

  mounted() {
    const iframeEl = this.$refs.contentIframe as HTMLIFrameElement;
    iframeEl.contentDocument?.location.replace(this.content.url);
  }

  handleEnlarge() {
    this.isEnlarge = !this.isEnlarge;
    if (!this.isEnlarge) {
      this.$emit('loaded');
    }
  }

  handleLoad() {
    this.send();
    this.$emit('loaded');
  }

  send() {
    const token = this.$getClemanClient().token;
    const contentIframe = this.$refs.contentIframe as HTMLIFrameElement;
    const origins = ['*'];

    origins.forEach((origin) => {
      contentIframe.contentWindow?.postMessage({ token }, origin);
    });
  }
}
</script>

<style scoped>
.wrapper {
  @apply w-full md:w-160 md:ml-12 md:mr-12 rounded-motif overflow-hidden shadow-lg;
  /* background-image: linear-gradient(to right, #6f41ef, #9f7ff7); */
  background-color: #6b6981;
  transition: 0.3s;
}
.enlarge {
  @apply fixed left-0 w-screen h-screen z-50;
  background-color: #6b6981;
  transition: 0.3s;
}
.iframe {
  @apply w-full h-80 overflow-hidden bg-white;
}
.iframe > iframe {
  @apply w-full h-full;
  /* 解决固宽后有黑边问题 */
  transform: scaleX(1.004) translateX(0.1%);
}

.setting {
  @apply flex items-center justify-center;
  flex: 0 0 2rem;
}
</style>
